import { createFileRoute } from "@tanstack/react-router";
import { Download } from "lucide-react";
import { AdminEmptyTab } from "@/components/dashboard/AdminEmptyTab";

export const Route = createFileRoute("/dashboard/admin/revenue-cancellations")({
  head: () => ({ meta: [{ title: "Cancellations · Admin" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <AdminEmptyTab
      title="Cancellations"
      description="Churned subscriptions, reasons, and win-back opportunities."
      stats={[
        { label: "Cancellations (30d)" },
        { label: "Churn rate" },
        { label: "Voluntary" },
        { label: "Involuntary" },
      ]}
      body="Cancellation events with reasons will appear here."
      primaryAction={{ label: "Export", icon: Download }}
      columns={["Customer", "Plan", "Cancelled", "Reason", "MRR lost"]}
    />
  ),
});
